module.exports = `${require.publicPath}base_login_bgc.78e663d6.png`;